/**
 * hooks/useRole.ts
 *
 * Returns the current user's role derived from Clerk publicMetadata.
 * Requires that the Clerk dashboard has `{ "role": "admin" | "user" }` set
 * under the user's publicMetadata.
 *
 * Setup reminder:
 *   Clerk Dashboard → Users → [user] → Metadata → publicMetadata
 *   Set value:  { "role": "admin" }
 */
import { useUser } from '@clerk/clerk-react';

export type UserRole = 'admin' | 'user' | 'loading';

export function useRole(): UserRole {
  const { isLoaded, user } = useUser();

  if (!isLoaded || !user) return 'loading';

  const meta = user.publicMetadata as Record<string, unknown> | null | undefined;
  return meta?.role === 'admin' ? 'admin' : 'user';
}

export function useIsAdmin(): boolean {
  return useRole() === 'admin';
}
